_ = require('underscore')

module.exports = require('frontend/components/abstract').extend
  template: require('./index.pug')

  data: ->
    images:       []
    activeIndex:  0

  methods:

    switchImage: ->
      return unless _.size(@images) > 0
      _images = @images.concat([])
      _.each _images, (img) => img.active = false
      index = @activeIndex + 1
      index = 0 if index >= _.size(_images)
      _images[index].active = true

      @.$set @, 'images', _images
      @.$set @, 'activeIndex', index

    startTimer: ->
      @_timer = setInterval (=> @switchImage()), 10000

    stopTime: ->
      clearInterval(@_timer) if @_timer?
      @_timer = null

  mounted: ->
    images = []
    _.each @.$refs.input.children, (child) ->
      images.push({ active: false, url: child.getAttribute('src') })
    return unless _.size(images) > 0

    index = parseInt(Math.random() * _.size(images))
    images[index].active = true

    @.$set @, 'images', images
    @.$set @, 'activeIndex', index

    @startTimer()

  beforeDestroy: ->
    @stopTimer()



// WEBPACK FOOTER //
// ./assets/js/frontend/components/hero_rotating_image/index.coffee